import Loader from "../../loader/Loader";
import {Button} from "antd";
import {SendOutlined} from "@ant-design/icons";
import {Campaign} from "../../../types/CampaignProps";
import "./campaign-resend-label.css";

interface CampaignResendLabelProps {
    campaign?: Campaign;
    membersWithPhoneNumbers?: number;
    onSendManualCampaignClick: (event: any) => void;
    isSending: boolean;
}

const CampaignResendLabel = ({ campaign, membersWithPhoneNumbers, onSendManualCampaignClick, isSending }: CampaignResendLabelProps) => {
    const shouldResend = campaign?.insights?.delivered && (campaign.insights.delivered) < (membersWithPhoneNumbers || 0);

    return (
        <>
            {shouldResend ? <div className="campaign-resend-container">
                {isSending ? <Loader size={24} /> : <Button icon={<SendOutlined color="#1575fb" size={24} />} className="link" type="link" onClick={onSendManualCampaignClick}>Resend to Unreached</Button>}
            </div> : null}
        </>
    );
}

export default CampaignResendLabel;